import { FieldPath, UseFormReturn } from "react-hook-form";

import { SaveIndicator } from "./SaveIndicator";
import { useSaveIndicator } from "@/hooks/useSaveIndicator";
import { InfoTooltip } from "@/components/form/InfoTooltip";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { cn } from "@/lib/utils";

export const AutosaveFormDateInput = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  infoTooltip,
  label,
  onBlur,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  infoTooltip?: string;
  label: string;
  onBlur: () => Promise<void> | void;
}) => {
  const { status, trigger } = useSaveIndicator();

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("min-w-0 text-slate-700", className)}>
            <FormLabel className="inline-flex w-full items-center justify-between">
              <span className="inline-flex min-w-0 items-center gap-1">
                <span className="truncate">{label}</span>
                {infoTooltip && <InfoTooltip className="shrink-0" content={infoTooltip} />}
              </span>
              <SaveIndicator status={status} />
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                className="bg-slate-50 text-black"
                onBlur={() => {
                  trigger(onBlur());
                }}
                onChange={(e) => {
                  field.onChange(e);
                  trigger(onBlur());
                }}
                type="date"
                value={field.value as string}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
